import styled, { css, keyframes } from 'styled-components';
import { Form as unformForm } from '@unform/web';

const bgDark = '#121212';
const cardDark = '#1E1E1E';
const textLight = '#EAEAEA';
const textSecondary = '#A0A0A0';
const border = 'rgba(255,255,255,0.1)';
const green = '#1DB954';
const amber = '#FFC107';
const red = '#dc3545';
const primary = '#256af4';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${bgDark};
  color: ${textLight};
  align-items: center;
  width: 100%;
  overflow-x: hidden;
  * {
    box-sizing: border-box;
  }

  .v2Modal {
    background: ${cardDark};
    border: 1px solid ${border};
    border-radius: 12px;
    padding: 28px 22px;
    color: ${textLight};
    max-width: 560px;
    width: 90vw;
  }
`;

export const Form = styled(unformForm)`
  width: 100%;
  max-width: 1080px;
  margin: 120px auto 0 auto;
  display: flex;
`;

const appear = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1080px;
  margin: 24px auto 40px auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 800;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 8px;
`;

export const TabButton = styled.button<{ active?: boolean }>`
  background: ${cardDark};
  color: ${(p) => (p.active ? textLight : textSecondary)};
  border: 1px solid ${(p) => (p.active ? amber : border)};
  padding: 8px 12px;
  border-radius: 10px;
  font-weight: 600;
`;

export const SectionHeader = styled.div`
  margin-top: 6px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
`;

export const PrimaryButton = styled.button<{ variant?: 'primary' | 'green' }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: ${(p) => (p.variant === 'primary' ? primary : green)};
  color: ${(p) => (p.variant === 'primary' ? '#fff' : '#000')};
  border: 0;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 700;
  white-space: nowrap;
`;

export const Table = styled.table`
  width: 100%;
  border-spacing: 0 12px;
  animation: ${appear} 0.3s ease both;

  thead th {
    background: ${bgDark};
    color: ${textSecondary};
    font-weight: 600;
    text-align: left;
    padding: 6px 10px;
  }

  tbody tr {
    background: ${cardDark};
    border: 1px solid ${border};
    border-radius: 12px;
    overflow: hidden;
  }
  tbody td {
    padding: 10px;
    vertical-align: middle;
  }
  tbody td:first-child { border-top-left-radius: 12px; border-bottom-left-radius: 12px; }
  tbody td:last-child { border-top-right-radius: 12px; border-bottom-right-radius: 12px; }

  @media (max-width: 640px) {
    thead { display: none; }
    tbody tr { display: block; margin-bottom: 12px; }
    tbody td,
    tbody td:first-child,
    tbody td:last-child {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 0;
      padding: 10px 12px;
      border-bottom: 1px solid ${border};
      width: 100%;
      box-sizing: border-box;
    }
    tbody td:last-child { border-bottom: 0; }
    tbody td::before { content: attr(data-label); color: ${textSecondary}; margin-right: 12px; }
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconButton = styled.button<{ tone?: 'normal' | 'danger' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  background: transparent;
  color: ${textLight};
  border: 1px solid ${border};
  border-radius: 10px;
  ${(p) =>
    p.tone === 'danger' &&
    css`
      color: ${red};
      border-color: ${red};
    `}
  &:hover { background: rgba(255,255,255,0.06); }
`;

export const ModalTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 12px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 12px;
`;

export const InlineGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const TesouroField = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

